import Vapi from 'vuex-rest-api';
import axios from '@/api/axios';

const store = new Vapi({
  axios,
  state: {
  },
})
  .get({
    action: 'getUfiForBom',
    path: ({ bomNumber }) => `internal/uniqueFormulaIdentifiers/bom/${bomNumber}`,
  })
  .getStore();

export default store;
